import {Module} from 'vuex';
import oApi from '@/js/hvac/talk/appoint.js'

/**
 * 用户分享数据模块
 * @type {Module}
 */
export const commonVuex = {
    namespaced: true,
    state: {
        feed_type:[],//体验反馈存放的数据数组
        feedObj:{},//存放体验反馈数据
    },
    mutations: {
        SaveFeedType (state,payload) {
            state.feed_type = payload
        },
        SaveFeedObj (state,payload) {
            state.feedObj = payload
        },
    },
    actions: {
        async getReportfeed({state,commit},payload) {
            await oApi.getReportfeed(payload).then (res => {
                let feed_type = res.data.result.feed_type
                // feed_type[2].items.unshift({content:'未选择',id:0})
                let feed = res.data.result.feed
                commit('SaveFeedType',feed_type)
                commit('SaveFeedObj',feed)
            })
        },
        
        async SendreportFeed({state,commit},payload) {
            await oApi.SendreportFeed(payload).then (res => {
                console.log(res,'结果');
            })
        },
    },
}

